import { ProductCard } from "./types";

// Product image dimensions - standardized to 600x400px
// This gives a 3:2 aspect ratio which is good for product photos
// Using this size allows for high-quality images on retina displays
// while still keeping file sizes reasonable

export const productCards: ProductCard[] = [
  {
    id: "flower",
    title: "Premium Flower",
    description: "Hand-selected, expertly cultivated cannabis flower.",
    image: "/images/kief-infused-joints-inside-dispensary.jpg",
    imageWebp: "/images/kief-infused-joints-inside-dispensary.webp",
    link: "/products",
    linkText: "Explore varieties →",
  },
  {
    id: "vape-carts",
    title: "Vape Cartridges",
    description: "High-quality concentrates in convenient cartridge form.",
    image: "/images/vape-cartridges.jpg",
    imageWebp: "/images/vape-cartridges.webp",
    link: "/products",
    linkText: "Browse selection →",
  },
  {
    id: "edibles",
    title: "Edibles",
    description: "Delicious treats infused with premium cannabis.",
    image: "/images/edibles.jpg",
    imageWebp: "/images/edibles.webp",
    link: "/products",
    linkText: "Discover edibles →",
  },
  {
    id: "concentrates",
    title: "Concentrates",
    description: "Potent extracts for the experienced cannabis consumer.",
    image: "/images/variations-of-thc-concentrates.gif", // GIF format - no WebP version
    link: "/products",
    linkText: "View concentrates →",
  },
];
